import { Hidden }                   from "@material-ui/core";
import * as React                   from "react";
import { FC }                       from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card }                     from "semantic-ui-react";
import Account                      from "../../../../domain/account/Account";
import AccountRoleType              from "../../../../domain/account/AccountRoleType";
import { ResKaState }               from "../../../../index";
import RouterDispatcher             from "../../../../infrastructure/redux/router/RouterDispatcher";

const CustomerImportSettingButton: FC = () => {
  const account: Account = useSelector((state: ResKaState) => state.account);
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());

  switch (account.role.value) {
    default:
      return null;
    case AccountRoleType.CORPORATION:
    case AccountRoleType.OFFICE:
      return (
        <>
          <Hidden smDown={ true }>
            <Card onClick={ () => routerDispatcher.customerImport() }>
              <Card.Content>
                <Card.Header>顧客情報をインポートする</Card.Header>
                <Card.Description>
                  所定のCSV形式のファイルから一括で顧客情報を登録することができます。
                </Card.Description>
              </Card.Content>
            </Card>
          </Hidden>

          <Hidden mdUp={ true }>
            <Card onClick={ () => routerDispatcher.customerImport() }>
              <Card.Content>
                <Card.Header>顧客情報をインポートする</Card.Header>
              </Card.Content>
            </Card>
          </Hidden>
        </>
      );
  }
};

export default CustomerImportSettingButton;
